import { OrdenTrabajo, TipoIncidencia } from '@/shared/interfaces';
import {
  MaterialesUtilizadosInstallOTTecAsig,
} from './equipos';
import { getEnvs, gridSizeMdLg12, gridSizeMdLg6, hasPermission, PRIORIDAD_INCIDENCIA_CHOICE, texto, useLoaders } from '@/shared';
import { Grid, Typography } from '@mui/material';
import { CustomAutocomplete, CustomAutocompleteArrString, CustomAutocompleteNoForm, CustomTextArea, TabTextLabel } from '@/shared/components/ui';
import { ONTOption } from '@/shared/interfaces/erp/mantenimiento-operaciones/ont.interface';
import { useFetchTiposIncidencias } from '@/shared/actions/erp';
import { CustomAlertCard } from '@/shared/components/ui/Alerts';
import { EquiposAdicionalesParaVentaActivaciones } from '@/erp/operaciones/activaciones/instalaciones/shared/components/form/EquiposAdicionalesParaVentaActivaciones';
import { PermissionsEnum } from '@/auth/interfaces';
import { useAuthStore } from '@/store/auth';
import { Button, Chip, Paper } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import PuntosDeRedVisita, { PuntoRed } from '@/erp/orden-servicio/orden-servicio-visita/components/otros-conceptos/PuntosDeRedVisita';
import OtrosConceptosVisita, { ConceptoVisita } from '@/erp/orden-servicio/orden-servicio-visita/components/otros-conceptos/OtrosConceptosVisita';
import type { ConfigPuntoRed, ConceptoCatalogo } from '@/erp/orden-servicio/orden-servicio-visita/components/otros-conceptos/usePreciosConceptosVisita';
import TipoInstalacionSelector from '@/erp/orden-servicio/orden-servicio-visita/components/tipo-instalacion/TipoInstalacionSelector';
import type { TipoInstalacion, TipoInstalacionSeleccion } from '@/erp/orden-servicio/orden-servicio-visita/components/tipo-instalacion/useTiposInstalacion';
import ReinstalacionAcVisita, { ReinstalacionAc } from '@/erp/orden-servicio/orden-servicio-visita/components/reinstalacion-ac/ReinstalacionAcVisita';
export type OTMaterialesInstallTecnicoFormTabProps = {
  form: any;
  ordenTrabajo: OrdenTrabajo;
  onlyView?: boolean;
  isloadingUbProducto?: boolean
  optionsONT?: ONTOption[]
  esVisita?: boolean
  // Puntos de Red (solo visitas)
  puntosRed?: PuntoRed[]
  onChangePuntosRed?: (v: PuntoRed[]) => void
  onGuardarPuntosRed?: () => void
  guardandoPuntosRed?: boolean
  puntoRedConfig?: ConfigPuntoRed
  ivaPorcentajePuntoRed?: number
  tieneCableUtp?: boolean
  puntosRedAprobado?: boolean
  puntosRedDirty?: boolean
  // Otros conceptos — el técnico solo asigna la serie (solo visitas)
  conceptosVisita?: ConceptoVisita[]
  onChangeConceptosVisita?: (v: ConceptoVisita[]) => void
  onGuardarSeriesConceptos?: () => void
  guardandoConceptos?: boolean
  conceptosDirty?: boolean
  ubicacionFlotaTec?: string
  catalogoConceptos?: ConceptoCatalogo[]
  // Tipo de instalación (solo visitas)
  tipoInstalacion?: TipoInstalacionSeleccion | null
  onChangeTipoInstalacion?: (v: TipoInstalacionSeleccion) => void
  tiposInstalacion?: TipoInstalacion[]
  // Reinstalación AC (solo visitas)
  reinstalacionAc?: ReinstalacionAc | null
  onChangeReinstalacionAc?: (v: ReinstalacionAc) => void
  onUploadFotoEvidencia?: (file: File) => Promise<{ url: string; fecha?: string }>
};

const OTMaterialesInstallTecnicoFormTab: React.FC<
  OTMaterialesInstallTecnicoFormTabProps
> = ({ ordenTrabajo, form, onlyView=false, optionsONT=[], isloadingUbProducto=false, esVisita=false,
       puntosRed=[], onChangePuntosRed, onGuardarPuntosRed, guardandoPuntosRed=false,
       puntoRedConfig, ivaPorcentajePuntoRed=15, tieneCableUtp=false, puntosRedAprobado=false,
       puntosRedDirty=false,
       conceptosVisita=[], onChangeConceptosVisita, onGuardarSeriesConceptos, guardandoConceptos=false,
       conceptosDirty=false,
       ubicacionFlotaTec, catalogoConceptos=[],
       tipoInstalacion=null, onChangeTipoInstalacion, tiposInstalacion=[],
       reinstalacionAc=null, onChangeReinstalacionAc, onUploadFotoEvidencia }) => {


  ///* fetch data ---------------
  const {
    data: tiposIncidenciaPaging,
    isLoading: isLoadingTiposIncidenciaPaging,
    // isRefetching: isRefetchingTiposIncidenciaPaging,
  } = useFetchTiposIncidencias({
    page_size: 100,
  });
  const currentUser = useAuthStore((s) => s.user);
  //const esVisita = ordenTrabajo.tipo_orden_trabajo === TipoOrdenServicioEnumChoice.VISITA

  useLoaders(isloadingUbProducto)
  return (
    <>
      {/* =============== EQUIPO ADICIONAL =============== */}
      {/* <EquipoAdicionalInstallTectAsig ordenTrabajo={ordenTrabajo!} /> */}

      {/* =============== EQUIPOS UTILIZADOS =============== */}
      <Grid {...gridSizeMdLg12} container item>
        <Typography variant="h6">{esVisita?'Equipos de Visita':'Equipos de Instalación'}</Typography>
      </Grid>

      <Grid {...gridSizeMdLg12} container item>
        {
          form.watch()?.estado_activacion == "GESTIONADA"
          && form.watch()?.equipos_utilizados?.[0]?.name != ordenTrabajo?.equipos_utilizados?.[0]?.name
          && <CustomAlertCard
            alertTitle="Cambio de ONT"
            alertMessage="Se ha seleccionado un ONT diferente a la seleccionada por activaciones."
            alertColor="warning"
            bgColorAlert="YELLOW"
          />
        }
      </Grid>
      <Grid {...gridSizeMdLg12} container item>
        <CustomAutocompleteNoForm<ONTOption>
          label="ONT a Utilizar"
          valueKey="name"
          actualValueKey="value"
          options={optionsONT || []}
          useContainsFilter={true}
          onChangeRawValue={value => {
            form.reset({
              ...form.getValues(),
              ont_a_utilizar: value,
              equipos_utilizados: [value]
            })
          }}
          isLoadingData={isloadingUbProducto}
          defaultValue={form.getValues()?.equipos_utilizados?.[0] || ""}
          size={gridSizeMdLg12}
          disabled={true}
        />
        {/* {
          form?.getValues()?.equipos_utilizados && form?.getValues()?.equipos_utilizados?.length > 0?
          <EquiposUtilizadosInstallOTTecAsig form={form} control={form.control} 
          ubicacion={form?.getValues()?.flota_data?.ubicacion!} onlyShow showToActivaciones />
          :
          <EquiposUtilizadosInstallOTTecAsig control={form.control} 
          ubicacion={form?.getValues()?.flota_data?.ubicacion!} />
        } */}
      </Grid>
      <Grid container item spacing={2} justifyContent={"center"}>
        <CustomAlertCard
          alertTitle="Recomendación"
          alertMessage={texto.verifique_ont_tecnico}
          bgColorAlert="YELLOW"
          alertColor="warning" />
      </Grid>
      {/* <EquiposUtilizadosInstallOTTecAsig control={form.control} 
      ubicacion={ordenTrabajo?.flota_data?.ubicacion!}/> */}

      {/* =============== MATERIALES UTILIZADOS =============== */}
      <Grid container item>
        {
          (form?.getValues()?.materiales_utilizados 
          && form?.getValues()?.materiales_utilizados?.length > 0
          && !(["EN ESPERA","ESPERA_RECOORDINADA"]?.includes(ordenTrabajo?.estado_orden_trabajo||"")))?
            <MaterialesUtilizadosInstallOTTecAsig form={form} 
            ubicacion={ordenTrabajo?.flota_data?.ubicacion!} showToActivaciones onlyShow esVisita={esVisita}/>
          :
          [1167].includes(currentUser?.user_id || 0) ? 
            <MaterialesUtilizadosInstallOTTecAsig form={form} 
            ubicacion={ordenTrabajo?.flota_data?.ubicacion!} enableNoOnt={true} esVisita={esVisita}/>
          : 
          !esVisita && hasPermission(PermissionsEnum.revision_contabilidad_tecnico)?
            <MaterialesUtilizadosInstallOTTecAsig form={form} 
            ubicacion={ordenTrabajo?.flota_data?.ubicacion!} showToActivaciones onlyShow esVisita={esVisita}/>
          :
            <MaterialesUtilizadosInstallOTTecAsig form={form} 
            ubicacion={ordenTrabajo?.flota_data?.ubicacion!} enableNoOnt={true} esVisita={esVisita}/>
        }
      </Grid>
      {/* <MaterialesUtilizadosInstallOTTecAsig form={form} 
      ubicacion={ordenTrabajo?.flota_data?.ubicacion!}/> */}

      {/* =============== EQUIPOS ADICIONALES PARA LA VENTA =============== */}

      <Grid {...gridSizeMdLg12} container item gap={1}>
        <Grid {...gridSizeMdLg6} alignContent={"center"}>
          <Typography variant="h6">Equipos Adicionales para la Venta</Typography>
        </Grid>
      </Grid>
      <EquiposAdicionalesParaVentaActivaciones form={form} onlyShow showChooseSerie={true} />
      {
        (form.getValues()?.equipos_adicionales_preventa?.length || 0) > 0 ?
          <Grid {...gridSizeMdLg12} container item>
            <Grid {...gridSizeMdLg12} container item>
              <Typography variant="body2" >
                Equipos adicionales solicitados por el cliente:
              </Typography>
            </Grid>
            {
              form.getValues()?.equipos_adicionales_preventa?.map((x: any, index: number) => (
                <Grid {...gridSizeMdLg12} container item key={"itemequipoadicionalpreventa-" + index}>
                  <Typography variant="body2">{x.descripcion} - <b>{x.cantidad} unidad/es</b></Typography>
                </Grid>
              ))
            }
          </Grid> :
          null
      }




      {/* <Grid {...gridSizeMdLg12} container justifyContent={"end"}>
      </Grid> */}

      {/* <ModalProductoSelectComponente
          onChange={(e) => {
            const aux: MaterialTransferido = {
              id: e.id_producto,
              cantidad: 1,
              codigo: e.codigo,
              series: [],
              contiene_serie: false,
              categoria_fcorporativa: CategoriaFCorporativaEnum.EQUIPOSADICIONALES,
              producto_data: {
                categoria_producto: e.categoria_producto,
                codigo: e.codigo,
                descripcion: e.descripcion,
                stock_actual: e.stock_actual,
                subcategoria_producto: e?.subcategoria_producto_data?.nombre || "N/A",
                precios: e.precios,
              },
            };
            addSelectedItemProducto(aux, MaterialesKey.ingresoProductos);
          }}
        /> */}
      {/* <Grid item xs={12}>
        <SampleTable<MaterialTransferido>
          // rowNumber={true}
          columns={columnsItemMaterialEquipoAdicional}
          data={[]
            // materialesEquiposAdicionales
            // || []
          }
        />
      </Grid> */}
      {/* ================ TIPO DE INSTALACIÓN (solo visitas) ================ */}
      {esVisita && (
        <Grid {...gridSizeMdLg12} item sx={{ mt: 3 }}>
          <Paper variant="outlined" sx={{ p: { xs: 2, sm: 2.5 }, borderRadius: 2 }}>
            <TipoInstalacionSelector
              value={tipoInstalacion}
              onChange={onChangeTipoInstalacion}
              readOnly={onlyView}
              selectionReadOnly={!onlyView}
              tipos={tiposInstalacion}
              onUploadFoto={onlyView ? undefined : onUploadFotoEvidencia}
            />
          </Paper>
        </Grid>
      )}

      {/* ================ REINSTALACIÓN AC (solo visitas) ================ */}
      {esVisita && (
        <Grid {...gridSizeMdLg12} item sx={{ mt: 2.5 }}>
          <Paper variant="outlined" sx={{ p: { xs: 2, sm: 2.5 }, borderRadius: 2 }}>
            <ReinstalacionAcVisita
              value={reinstalacionAc}
              onChange={onChangeReinstalacionAc}
              readOnly={onlyView}
            />
          </Paper>
        </Grid>
      )}

      {/* ================ OTROS CONCEPTOS — asignar serie (solo visitas) ========= */}
      {esVisita && (
        <Grid {...gridSizeMdLg12} item sx={{ mt: 2.5 }}>
          <Paper variant="outlined" sx={{ p: { xs: 2, sm: 2.5 }, borderRadius: 2 }}>
            <Typography variant="subtitle1" fontWeight={800}>Otros conceptos / equipos</Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Selecciona la serie a entregar de cada equipo (definidos por ventas/activaciones).
            </Typography>
            <OtrosConceptosVisita
              value={conceptosVisita}
              onChange={onChangeConceptosVisita}
              serieEditableOnly={!onlyView}
              readOnly={onlyView}
              ubicacionFlota={ubicacionFlotaTec}
              conceptos={catalogoConceptos}
              onUploadFoto={onlyView ? undefined : onUploadFotoEvidencia}
            />
            {!onlyView && onGuardarSeriesConceptos && conceptosVisita.length > 0 && (
              <Grid container item justifyContent="flex-end" alignItems="center" gap={1} sx={{ mt: 2 }}>
                {!conceptosDirty && (
                  <Typography variant="caption" color="success.main">
                    ✓ Series guardadas
                  </Typography>
                )}
                <LoadingButton
                  variant="contained"
                  color="secondary"
                  loading={guardandoConceptos}
                  disabled={!conceptosDirty}
                  onClick={onGuardarSeriesConceptos}
                >
                  Guardar series de equipos
                </LoadingButton>
              </Grid>
            )}
          </Paper>
        </Grid>
      )}

      {/* ================ PUNTOS DE RED (solo visitas) ================ */}
      {esVisita && (
        <Grid {...gridSizeMdLg12} item sx={{ mt: 2.5 }}>
          <Paper variant="outlined" sx={{ p: { xs: 2, sm: 2.5 }, borderRadius: 2 }}>
            <Grid container item alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
              <Typography variant="subtitle1" fontWeight={800}>Puntos de Red</Typography>
              {puntosRed.length > 0 && (
                <Chip
                  size="small"
                  label={puntosRedAprobado ? "Aprobado por Activaciones" : "Pendiente de aprobación"}
                  color={puntosRedAprobado ? "success" : "warning"}
                  variant={puntosRedAprobado ? "filled" : "outlined"}
                />
              )}
            </Grid>
            <PuntosDeRedVisita
              value={puntosRed}
              onChange={onChangePuntosRed}
              readOnly={onlyView}
              config={puntoRedConfig}
              ivaPorcentaje={ivaPorcentajePuntoRed}
              tieneCableUtp={tieneCableUtp}
              conceptosDisponibles={conceptosVisita
                .filter((c) => catalogoConceptos.find((cat) => cat.concepto === c.concepto)?.permite_punto_red)
                .map((c) => c.concepto)
                .filter((v, i, a) => !!v && a.indexOf(v) === i)}
              onUploadFoto={onlyView ? undefined : onUploadFotoEvidencia}
            />
            {!onlyView && onGuardarPuntosRed && (
              <Grid container item justifyContent="flex-end" alignItems="center" gap={1} sx={{ mt: 2 }}>
                {!puntosRedDirty && puntosRed.length > 0 && (
                  <Typography variant="caption" color="success.main">
                    ✓ Guardado{puntosRedAprobado ? ' y aprobado' : ' (pendiente de aprobación)'}
                  </Typography>
                )}
                <LoadingButton
                  variant="contained"
                  color="secondary"
                  loading={guardandoPuntosRed}
                  disabled={!puntosRedDirty}
                  onClick={onGuardarPuntosRed}
                >
                  Guardar puntos de red
                </LoadingButton>
              </Grid>
            )}
          </Paper>
        </Grid>
      )}

      {/* ================ INCIDENCIAS ================ */}
      <TabTextLabel text="Incidencias" pt={1} pb={1} />
      <>
        {/* "Tipo de Incidencia" y "Prioridad de la Incidencia": se ocultan a pedido
            SOLO en visitas; en instalaciones se mantienen como en prod. */}
        {!esVisita && (<>
        <CustomAutocomplete<TipoIncidencia>
          label="Tipo de Incidencia"
          name="incidencia"
          options={tiposIncidenciaPaging?.data.data || []}
          valueKey="nombre"
          actualValueKey="codigo"
          defaultValue={form.getValues().incidencia || ""}
          isLoadingData={isLoadingTiposIncidenciaPaging}
          control={form.control}
          error={form?.formState?.errors?.incidencia}
          helperText={form?.formState?.errors?.incidencia?.message}
          size={gridSizeMdLg6}
          required={false}
          onChangeValue={() => {
            form.setValue("prioridad_incidencia", "");
          }}
          disabled={onlyView}
        />
        <CustomAutocompleteArrString
          label="Prioridad de la Incidencia"
          name="prioridad_incidencia"
          control={form.control}
          defaultValue={form.getValues("prioridad_incidencia")}
          options={PRIORIDAD_INCIDENCIA_CHOICE}
          isLoadingData={false}
          error={form?.formState?.errors?.prioridad_incidencia}
          helperText={form?.formState?.errors?.prioridad_incidencia?.message}
          size={gridSizeMdLg6}
          disableClearable
          required={false}
          disabled={onlyView}
        />
        </>)}
        <CustomTextArea
          label="Datos Preventivos"
          name="observacion_incidencia"
          control={form.control}
          defaultValue={form.getValues("observacion_incidencia") || ""}
          error={form?.formState?.errors?.observacion_incidencia}
          helperText={form?.formState?.errors?.observacion_incidencia?.message}
          required={false}
          disabled={onlyView}
        />
        <Grid item xs={12}>
          <hr style={{ border: 'none', height: '1px', backgroundColor: '#ccc' }} />
        </Grid>
        {/* <CustomTextArea
          label="Observación Técnico"
          name="observacion_tecnico"
          control={form.control}
          defaultValue={form.getValues("observacion_tecnico") || ""}
          error={form?.formState?.errors?.observacion_tecnico}
          helperText={form?.formState?.errors?.observacion_tecnico?.message}
          required={false}
          disabled={onlyView}
        /> */}
      </>

    </>
  );
};

export default OTMaterialesInstallTecnicoFormTab;
